// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"417594c4","73":"eec3a22d","177":"5459ca05","183":"eec3a22d","398":"eec3a22d","475":"52fad8a6","921":"eec3a22d"}[chunkId] + ".chunk.css";
};